import Footer from "../Footer/FootersLayoutsTypeThird";
import React from "react";
import ContactUsForm from "../ContactUsForm/FormsLayoutsTypeFirst";
import HeroLayoutsTypeSixth from "./HeroLayoutsTypeSixth/HeroLayoutsTypeSixth";
import MainFeature from "./MainFeature/MainFeature";
import Testimonials from "./Testimonials/Testimonials";
import AssetFeature from "./AssetFeature/AssetFeature";
import AssetFeatureCarousel
    from "../../FeaturesLayouts/FeaturesLayoutsTypeSeventeenth/AssetFeatureCarousel";
import FeatureSlides from "./FeatureSlides/FeatureSlides";

const HomePage = () => {
    return <div>
        <HeroLayoutsTypeSixth/>
        <MainFeature/>
        {/*<AssetFeature/>*/}
        {/*<FeaturesLayoutsTypeEleventh />*/}
        {/*<FeaturesLayoutsTypeTwelve />*/}
        {/*<FeaturesLayoutsTypeThirteen />*/}
        {/*<FeaturesLayoutsTypeFourteen />*/}
        {/*<FeaturesLayoutsTypeFifteen />*/}
        {/*<FeaturesLayoutsTypeSixteen />*/}
        <FeatureSlides />
        <AssetFeatureCarousel />
        {/*<FeaturesLayoutsTypeNineteen />*/}
        {/*<FeaturesLayoutsTypeTwenty />*/}
        {/*<FeaturesLayoutsTypeTwentyOne />*/}
        {/*<DistributorCollaborationFeature />*/}
        <Testimonials/>
        <ContactUsForm />
        <Footer />
    </div>
}

export default HomePage;
